module.exports = __webpack_public_path__ + "28c5e94e4b523521c68cc6875caab0e9.svg";